import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

type EmptyStateProps = {
    icon?: IconDefinition
    title: string
    /** One line on what to do about it. An empty state that only says "empty" is a dead end. */
    hint?: string
    action?: ReactNode
    className?: string
}

export const EmptyState = ({ icon, title, hint, action, className }: EmptyStateProps) => (
    <div
        className={twMerge(
            'col-span-full flex flex-col items-center justify-center text-center gap-3 py-16 px-4',
            className
        )}
    >
        {icon && (
            <div className='h-12 w-12 flex items-center justify-center border border-white/15 rounded-full'>
                <FontAwesomeIcon icon={icon} className='text-lg text-white/40' />
            </div>
        )}
        <h2 className='text-lg font-bold uppercase tracking-wide'>{title}</h2>
        {hint && <p className='text-sm text-white/50 max-w-xs'>{hint}</p>}
        {action}
    </div>
)

/**
 * A block that occupies the same space the real content will. Sized by the caller so it matches
 * the finished layout — a skeleton whose shape differs from the result just relocates the jump.
 */
export const Skeleton = ({ className }: { className?: string }) => (
    <div className={twMerge('bg-white/5 border border-white/10 rounded animate-pulse', className)} />
)
